
/* styles */
require("!!vue-style-loader!css-loader!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2c0058be&scoped=true!sass-loader!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditComment.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditComment.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-2c0058be!./../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditComment.vue"),
  /* scopeId */
  "data-v-2c0058be",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/EditComment.vue
// module id = 44
// module chunks = 0